<div class="text-center" data-uit="loading-indicator-with-text">
    <ca-icon name="loading" size="m"></ca-icon>
    <p class="mt-3"><ng-content></ng-content></p>
</div>
